import React from 'react';
import { Divider } from 'semantic-ui-react'

const VerOfer1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel, handleClickSel1}) => {
  const a251505 = autorizacUA.findIndex( autorizac => autorizac === "251505" );
  const a251510 = autorizacUA.findIndex( autorizac => autorizac === "251510" );
  const a251515 = autorizacUA.findIndex( autorizac => autorizac === "251515" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a251505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      {a251510!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }

      {(a251505!==-1||a251510!==-1) &&
      <Divider inverted />
      }

      {a251515!==-1 &&
      <div>
      <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
        <i className="large settings yellow icon"></i>
        Configurar
      </button>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large newspaper outline violet icon"></i>
        Servicios
      </button>

      <Divider inverted />
      </div>
      }

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerOfer1
